module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-4.8390e786.jpg";